import { render, staticRenderFns } from "./JEditableTable.vue?vue&type=template&id=28866158&scoped=true&"
import script from "./JEditableTable.vue?vue&type=script&lang=js&"
export * from "./JEditableTable.vue?vue&type=script&lang=js&"
import style0 from "./JEditableTable.vue?vue&type=style&index=0&id=28866158&lang=less&scoped=true&"
import style1 from "./JEditableTable.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28866158",
  null
  
)

export default component.exports